import styles from "./CancellationReasonPopup.module.scss";
import React from "react";
import closeIcon from "../../../../../assets/images/icons/close-grey.svg";
import MainTitle from "../../../../../components/ui/MainTitle/MainTitle";
import { useTranslation } from "react-i18next";
import { useGetUserSubscriptionCancellationReasonQuery } from "../../../../../api/queries/useUserSubscriptionQuery";

interface CancellationReasonPopupProps {
  closePopup: () => void;
  userSubscriptionId: string;
}

const CancellationReasonPopup: React.FC<CancellationReasonPopupProps> = ({
  closePopup,
  userSubscriptionId,
}) => {
  const { t } = useTranslation();

  const { data: userSubscriptionCancellationReason = null } =
    useGetUserSubscriptionCancellationReasonQuery(userSubscriptionId);

  if (!userSubscriptionCancellationReason) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <button onClick={closePopup} className={styles.closeBtn}>
          <img src={closeIcon} alt="close" />
        </button>
        <MainTitle titleSize={20} text={t("CancellationReason")} />
        <div className={`${styles.popupContent} custom-scroll`}>
          <div className={styles.item}>
            <h4 className={styles.title}>{t("Reason")}</h4>
            <p className={styles.description}>{t(userSubscriptionCancellationReason.reason)}</p>
          </div>
          <div className={styles.item}>
            <h4 className={styles.title}>{t("Comment")}</h4>
            <p className={styles.description}>{userSubscriptionCancellationReason.comment}</p>
          </div>
          <div className={styles.item}>
            <h4 className={styles.title}>{t("HowLikelyAreYouToRecommendClubPassToAFriend")}</h4>
            <p className={styles.description}>
              {userSubscriptionCancellationReason.rating ||
              userSubscriptionCancellationReason.rating === 0
                ? userSubscriptionCancellationReason.rating
                : "-"}
            </p>
          </div>
          <div className={styles.item}>
            <h4 className={styles.title}>{t("Why")}</h4>
            <p className={styles.description}>
              {userSubscriptionCancellationReason.additionalComment
                ? userSubscriptionCancellationReason.additionalComment
                : "-"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationReasonPopup;
